import { ExclamationCircleFilled, WarningFilled } from '@ant-design/icons'
import { OrderModal } from '@components/OrderWizard/OrderModal'

import { useState } from 'react'
import type { AlertType } from '../types'
import { ControlPanelAlert } from './ControlPanelAlert'
import { GraviButton } from '@gravitate-js/excalibrr'

type OrderAlertProps = {
  alert: AlertType
  handleResolve: () => void
}

export function OrderAlert({ alert, handleResolve }: OrderAlertProps) {
  const [showOrderModal, setShowOrderModal] = useState(false)
  const [selectedOrderId, setSelectedOrderId] = useState()

  function handleOpenOrderModal() {
    setSelectedOrderId(alert.payload?.order_id)
    setShowOrderModal(true)
  }

  function handleCloseOrderModal() {
    setShowOrderModal(false)
    setSelectedOrderId(undefined)
  }

  return (
    <>
      <ControlPanelAlert
        alert={alert}
        icon={alert.severity === 'error' ? <ExclamationCircleFilled /> : <WarningFilled />}
        actions={<GraviButton buttonText={'View Order'} onClick={handleOpenOrderModal} />}
        handleResolve={handleResolve}
      />
      {selectedOrderId && (
        <OrderModal
          showingModal={showOrderModal}
          closeModal={handleCloseOrderModal}
          selectedOrder={selectedOrderId}
          resetTimeoutDelay={250}
        />
      )}
    </>
  )
}
